import React, { useState, useRef, useEffect } from 'react'

const OFFICES = [
  'US Senate', 'US House', 'Downballot', 'Governor',
  'Issue', 'Presidential', 'National',
]

const YELLOW = '#eab308'
const BORDER = '#e5e7eb'

const selectStyle = {
  width: '100%',
  border: `1px solid ${BORDER}`,
  borderRadius: 4,
  backgroundColor: 'transparent',
  padding: '2px 6px',
  fontSize: 12,
  color: '#111827',
  outline: 'none',
  cursor: 'pointer',
  fontFamily: 'inherit',
  boxSizing: 'border-box',
}

export default function InlineEditCell({ value, field, onSave }) {
  const [editing, setEditing] = useState(false)
  const [editValue, setEditValue] = useState(value || '')
  const inputRef = useRef(null)

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus()
      inputRef.current.select()
    }
  }, [editing])

  const handleSave = () => {
    setEditing(false)
    if (editValue !== (value || '')) {
      onSave(editValue || null)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSave()
    if (e.key === 'Escape') {
      setEditValue(value || '')
      setEditing(false)
    }
  }

  if (field === 'office') {
    return (
      <select
        value={value || ''}
        onChange={e => onSave(e.target.value || null)}
        style={selectStyle}
      >
        <option value="">—</option>
        {OFFICES.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    )
  }

  if (editing) {
    return (
      <input
        ref={inputRef}
        value={editValue}
        onChange={e => setEditValue(e.target.value)}
        onBlur={handleSave}
        onKeyDown={handleKeyDown}
        style={{
          width: '100%',
          minWidth: '5rem',
          border: `2px solid ${YELLOW}`,
          borderRadius: 4,
          backgroundColor: '#fff',
          padding: '2px 6px',
          fontSize: 12,
          color: '#111827',
          outline: 'none',
          fontFamily: 'inherit',
          boxSizing: 'border-box',
        }}
      />
    )
  }

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={() => { setEditValue(value || ''); setEditing(true) }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          setEditValue(value || '')
          setEditing(true)
        }
      }}
      title="Click to edit"
      style={{
        display: 'block',
        minHeight: 22,
        cursor: 'text',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        borderRadius: 4,
        padding: '2px 6px',
        fontSize: 12,
        transition: 'background-color 0.15s',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = '#fffbeb'
        e.currentTarget.style.boxShadow = `0 0 0 1px rgba(234, 179, 8, 0.4)`
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent'
        e.currentTarget.style.boxShadow = 'none'
      }}
    >
      <span style={{ color: value ? '#111827' : '#9ca3af' }}>{value || '—'}</span>
    </span>
  )
}
